import { Box, forwardRef, Link, Tooltip } from '@chakra-ui/react';
import { Text } from '@main/complykit/components/text';
import { useTranslation } from 'react-i18next';

import { shortcutHint, ShortcutModifier } from '../../shortcut';

interface RenderLinkProps {
  value: string | undefined;
}

export const RenderLink = forwardRef<RenderLinkProps, 'p'>(({ value }, ref) => {
  const { t } = useTranslation('ui');

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    // Check if CMD (Mac) or CTRL (Windows) key is pressed
    if (e.metaKey || e.ctrlKey) {
      window.open(e.currentTarget.href, '_blank');
      // Stop propogating event to Cell to prevent triggering edit mode
      e.stopPropagation();
    }
  };

  return (
    <Tooltip
      placement="top"
      openDelay={500}
      label={t('editable.openLinkTooltip', {
        key: shortcutHint(ShortcutModifier.Ctrl, 'Click'),
      })}
    >
      <Box py={4} px={2}>
        <Text size="inherit" isTruncated ref={ref}>
          <Link color="purple.400" href={value} onClick={handleClick}>
            {value}
          </Link>
        </Text>
      </Box>
    </Tooltip>
  );
});
